import { SettingsSearchResult } from "./settings";

export class SettingsSearchResultsPopoverArgs {
  onClick: (url: string) => Promise<void>;
  searchPopoverData: { results: SettingsSearchResult[], search: string, row: number }
}

export class SettingsSearchResultsPopover {
  public onClick!: (url: string) => Promise<void>;
  public searchData = { results: [], search: "", row: 0 };

  public activate(args: SettingsSearchResultsPopoverArgs) {
    this.onClick = args.onClick;
    this.searchData = args.searchPopoverData;
  }

  public highlightedSearchHTML(search: string, word: string): string {
    return word.replace(new RegExp(search, 'ig'), match => {
      return `<strong>${match}</strong>`;
    });
  }

  public gotoSettingsPage(url: string) {
    if (this.onClick) this.onClick(url);
  }
}
